import React from 'react';

interface FlippableStatProps {
  front: React.ReactNode;
  back: React.ReactNode;
  isFlipped: boolean;
  className?: string;
}

export const FlippableStat: React.FC<FlippableStatProps> = ({
  front,
  back,
  isFlipped,
  className,
}) => {
  return (
    <div
      className={`relative flex h-full w-full flex-col ${className}`}
      // style={{ perspective: '1000px' }}
    >
      <div
        className={`flip-container ${isFlipped ? 'flipped' : ''}`}
        style={{
          perspective: '1000px',
          transformStyle: 'preserve-3d',
          transition: 'transform 0.6s',
          transform: isFlipped ? 'rotateY(180deg)' : '',
        }}
      >
        {/* Front Side */}
        <div
          data-component="KpiCardFront"
          className="front"
          style={{
            position: isFlipped ? 'absolute' : 'relative',
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            visibility: isFlipped ? 'hidden' : 'visible',
          }}
        >
          {front}
        </div>

        {/* Back Side */}
        <div
          data-component="StatCardBack"
          className="back"
          style={{
            position: isFlipped ? 'relative' : 'absolute',
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)',
            visibility: isFlipped ? 'visible' : 'hidden',
          }}
        >
          {back}
        </div>
      </div>
    </div>
  );
};
